// Use IIFE to avoid polluting the global namespace
(function () {
  const languageConfigs = {
    en: {
      eligibleProductIds: [47065993380185, 47065993347417],
      additionalText: "+ 16 Growing Pods included",
      cartTitle: "In your cart",
      buttonConfirmText: "Confirm my selection",
      stepTitle: "Choose your 4 pods",
      stepDescription: "Choose your favorite varieties!",
    },
    "fr-FR": {
      eligibleProductIds: [47065993380185, 47065993347417],
      additionalText: "+ 16 mottes incluses",
      cartTitle: "Dans votre panier",
      buttonConfirmText: "Je valide mon choix",
      stepTitle: "Choisissez vos 4 mottes",
      stepDescription: "Choisissez vos variétés préférées !",
    },
  };
  const productNameTranslations = {
    en: {
      "Ciboulette Commune": "Common Chives",
      "Coriandre Cultivée": "Cultivated Coriander",
      "Laitue à Couper": "Cutting Lettuce",
      "Mâche à Grosses Graines": "Lamb's Lettuce",
      "Menthe Verte": "Spearmint",
      "Epinard Géant d'Hiver": "Giant Winter Spinach",
      "Mini Carotte": "Baby Carrots",
      "Mini Navet": "Mini Turnips",
      "Mini Poivron": "Mini Peppers",
      "Persil Plat": "Flat-Leaf Parsley",
      "Piment de Cayenne": "Cayenne Pepper",
      "Radis Ronds": "Round Radishes",
      "Romarin Officinal": "Common Rosemary",
      "Thym Commun": "Common Thym",
      "Tomate Cerise": "Cherry Tomato",
    },
  };
  const CART_ITEM_SELECTOR = "#MainContent > div.loop";
  const CART_INTERVAL_MS = 300;
  const CART_UPDATE_MS = 500;

  const lang = document.documentElement.getAttribute("lang") || "en"; // Default to English
  const config = languageConfigs[lang];

  window.addEventListener("load", () => {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        handleCartData(data, config);
        // Translation step here, after cart data is handled
        translateProductNames(lang);
      })
      .catch((error) => console.error("Failed to fetch cart data:", error)); // Error handling
  });
  function translateProductNames(lang) {
    const translations = productNameTranslations[lang];
    if (!translations) return; // If no translation map for this language, exit the function

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((newNode) => {
            // Check if the new node is the element you're watching for, or contains it
            if (newNode.nodeType === Node.ELEMENT_NODE) {
              if (newNode.matches(".loop-bundle-product-card-title")) {
                applyTranslation(newNode, translations);
              } else {
                newNode
                  .querySelectorAll(".loop-bundle-product-card-title")
                  .forEach((element) => {
                    applyTranslation(element, translations);
                  });
              }
            }
          });
        }
      });
    });

    // Start observing the body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function applyTranslation(element, translations) {
    const originalName = element.innerText.trim();
    const translatedName = translations[originalName];
    if (translatedName) {
      element.innerText = translatedName;
    } else {
      console.warn(
        `No translation found for product '${originalName}' in language '${lang}'.`
      );
    }
  }
  function handleCartData(data, config) {
    const cartItemsHTML = data.items
      .map((item) => generateCartItemHTML(item, config))
      .join("");

    waitForElement(CART_ITEM_SELECTOR, () => {
      removeSpecifiedElements();
      updateClassList();
      insertContent(cartItemsHTML, config);
    });
  }

  function generateCartItemHTML(product, config) {
    const customText = config.eligibleProductIds.includes(product.id)
      ? config.additionalText
      : "";
    const productPrice = Math.round(product.final_price / 100) + "€";

    return `
      <div class="side-cart--subwrap">
        <div>
          <p class="side-product--title">${product.product_title}</p>
        </div>
        <div>
          <p>${customText}</p>
        </div>
        <div class="side-cart--price">
          <p>${productPrice}</p>
        </div>
      </div>
    `;
  }

  function waitForElement(selector, callback) {
    const intervalId = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        callback();
      }
    }, CART_INTERVAL_MS);
  }

  // Removes specified elements from the DOM
  function removeSpecifiedElements() {
    const selectorsToRemove = [
      "#loop-background > div > div.loop-bundle-header-wrapper > div.loop-bundle-image-container-wrapper.d-flex.justify-content-center.align-items-center.flex-column",
    ];

    selectorsToRemove.forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) {
        element.remove();
      }
    });
  }

  // Updates the class list of an element in the DOM
  function updateClassList() {
    const classListToUpdate = document.querySelector(
      "#MainContent > div.loop > div.loop-bundle-footer.d-flex.justify-content-center.p-3.flex-column"
    );

    if (classListToUpdate) {
      classListToUpdate.classList.remove("justify-content-center");
    }
  }

  function insertContent(cartItemsHTML, config) {
    setTimeout(() => {
      insertSideCart(cartItemsHTML, config);
      insertTitle(config);
      insertCart(config);
    }, CART_UPDATE_MS);
  }

  function insertSideCart(cartItemsHTML, config) {
    const sideCart = document.createElement("div");
    sideCart.innerHTML = `
      <div class="side--cart-top">
        <div>
          <p class="side-cart--title">${config.cartTitle}</p>
        </div>
        <div class="side-cart--potager">
          ${cartItemsHTML}
        </div>
        <p class="button button-false">${config.buttonConfirmText}</p>
      </div>
    `;

    const container = document.querySelector(CART_ITEM_SELECTOR);
    if (container) {
      container.insertBefore(sideCart, container.firstChild);
    }
  }

  function insertTitle(config) {
    const titleElement = document.createElement("div");
    titleElement.innerHTML = `
      <div class="step--content-title">
        <div>
          <h2 class="subp-title">${config.stepTitle}</h2>
        </div>
        <div>
          <span class="step--desc">${config.stepDescription}</span>
        </div>
      </div>
    `;

    const headerWrapper = document.querySelector(
      "#loop-background > div > div.loop-bundle-header-wrapper"
    );
    if (headerWrapper) {
      headerWrapper.insertBefore(titleElement, headerWrapper.children[1]);
    }
  }

  // Inserts the cart HTML into the DOM
  function insertCart(config) {
    const cartElement = document.createElement("div");
    cartElement.innerHTML = `
    <div>
      <div>
        <p>${config.cartTitle}</p>
      </div>
      <div></div>
    </div>
  `;

    const footerElement = document.querySelector(
      "#MainContent > div.loop > div.loop-bundle-footer.d-flex.p-3.flex-column"
    );
    if (footerElement) {
      footerElement.insertBefore(cartElement, footerElement.children[1]);
    }
  }

  // DOMContentLoaded event to set up the page once it's fully loaded
  document.addEventListener("DOMContentLoaded", function () {
    setupCartInteractions();
  });

  // Set up interactions with the cart, like button clicks and paragraph updates
  function setupCartInteractions() {
    // Selectors for interactive elements
    const targetButtonSelector =
      ".loop-bundle-footer > div.d-flex.justify-content-center.align-items-center > button";
    const targetParagraphSelector =
      "#MainContent > div.loop > div:nth-child(1) > div > p";

    // Wait for interactive elements before setting up interactions
    waitForElement(targetButtonSelector, () => {
      const targetButton = document.querySelector(targetButtonSelector);
      waitForElement(targetParagraphSelector, () => {
        const targetParagraph = document.querySelector(targetParagraphSelector);
        setupObserver(targetButton, targetParagraph);
      });
    });
  }

  // Observer setup for button and paragraph interaction
  function setupObserver(targetButton, targetParagraph) {
    // Update paragraph class based on the button state
    updateParagraphClass(targetButton, targetParagraph);

    // MutationObserver to watch for changes in button attributes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          updateParagraphClass(targetButton, targetParagraph);
        }
      });
    });

    // Start observing the target button for attribute changes
    observer.observe(targetButton, { attributes: true });

    // Add click event listener to the paragraph
    targetParagraph.addEventListener("click", () => {
      if (!targetButton.disabled) {
        targetButton.click();
      }
    });

    // Function to disconnect the observer when it's no longer needed
    return () => observer.disconnect();
  }

  // Function to update the paragraph class based on the button state
  function updateParagraphClass(button, paragraph) {
    if (button.getAttribute("disabled") !== null) {
      paragraph.classList.add("button-false");
      paragraph.classList.remove("button-true");
    } else {
      paragraph.classList.add("button-true");
      paragraph.classList.remove("button-false");
    }
  }

  // Other functions like insertSideCart, insertTitle, insertCart, etc., are assumed to exist
  // They should be refactored in a similar manner to the functions shown above.
})(); // End of IIFE

const buttonNames = ["Mois d'un mois", "1 à 2 mois", "Plus de 2 mois"];

const buttonNames_2 = [
  "18 jours",
  "21 jours",
  "28 jours",
  "30 jours",
  "45 jours",
  "60 jours",
  "10 semaines",
];

const intervalId = setInterval(() => {
  const targetElement = document.querySelector(
    ".loop-bundle-select-product-title"
  );
  if (targetElement) {
    clearInterval(intervalId);
    const container = document.querySelector(".loop-products-align");
    if (container) {
      const divs = container.getElementsByTagName("div");
      for (let i = 0; i < divs.length; i++) {
        if (divs[i].parentNode === container) {
          divs[i].classList.add("product");
        }
      }
    }

    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("button-container"); // Add a class to the div container

    buttonContainer.innerHTML = `<div id="FacetsWrapperDesktop" class="facets__wrapper"><div>
    <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
      Trier par :
    </h2>
  </div>

<div class="urban-flex filter--wrap">
        <details  class="facets__disclosure js-filter" >
          <summary class="facets__summary caption-large focus-offset" aria-label="Durée de croissance ()" role="button" aria-expanded="false" aria-controls="Facet-1-template--19569769808217__product-grid">
            <div>
              <span>Durée de croissance
</span>
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path></svg>

            </div>
          </summary>

          <div class="">

          <ul class="hidden filter1 facets__list list-unstyled no-js-hidden">

          </ul>


          </class>
          </div>
          
        </details>
      

        

        
      
</div>
<noscript>
  <button type="submit" class="facets__button-no-js button button--secondary">
    Trier par :
  </button>
</noscript>
</div> `;

    targetElement.appendChild(buttonContainer);
    const ulElement = document.querySelector(
      "#FacetsWrapperDesktop > div.urban-flex.filter--wrap > details:nth-child(1) > div > ul"
    );
    console.log(ulElement);
    buttonNames.forEach((name, index) => {
      const button = document.createElement("li");
      button.textContent = name;
      button.classList.add("filter_button_loop");
      const char = String.fromCharCode(97 + index);
      // button.setAttribute('onclick', `${name.replace(/\s/g, '')}`);
      button.setAttribute(
        "onclick",
        `${name.replace(/[^a-zA-Z]/g, "")}${char.replace(/[^a-zA-Z]/g, "")}()`
      ); // Add brackets () at the end of the value

      ulElement.appendChild(button);
    });
    console.log("Code executed successfully!");
    $(document).ready(function () {
      $(".facets__summary").on("click", function () {
        // Toggle the visibility of the <ul> element inside the <details> parent
        $(this).parent().find("ul").toggleClass("hidden");
      });
    });
  }
}, 100);

// BREAKFAST HANDLE TITELE
// Create the interval and store it in a variable
var filter = setInterval(function () {
  moisb(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function moisb() {
  const breakfastList = [
    "43778405859562",
    "39364534010023",
    "8018444452074",
    "8018444517610",
    "6577045012647",
    "6577095278759",
    "8018444550378",
    "6561282785447",
    "8018443993322",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (breakfastList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF BREAFAST HANDLE TITLE

//  VEGAN id product TITELE
// Create the interval and store it in a variable
var filter_vegan = setInterval(function () {
  Moisdunmoisa(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_vegan);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function Moisdunmoisa() {
  const veganfastList = [
    "5934779760807",
    "8018444058858",
    "8018443895018",
    "8018444746986",
    "6835151503527",
    "6835159761063",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (veganfastList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF VEGAN HANDLE TITLE

// START OF Keto ID PRODUCT TITLE
// Create the interval and store it in a variable
var filter_keto = setInterval(function () {
  Plusdemoisc(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_keto);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function Plusdemoisc() {
  const ketoList = [
    "8018444255466",
    "8018444288234",
    "6577416110247",
    "8534609461552",
    "8534602154288",
    "8534591504688",
    "8534426550576",
    "8534424191280",
    "8534421700912",
    "8534418424112",
    "8526854160688",
    "8526850883888",
    "8526844559664",
    "8526840987952",
    "8523640471856",
    "8519285211440",
    "8519279608112",
    "8519276233008",
    "8519274496304",
    "8519273513264",
    "8519265845552",
    "8465066787120",
    "8465060102448",
    "8465049551152",
    "8465043292464",
    "8465033789744",
    "8465026842928",
    "8464832692528",
    "8464799924528",
    "8464795894064",
    "8464791175472",
    "8464785310000",
    "8464782688560",
    "8464778330416",
    "8445069820208",
    "8445068017968",
    "8445065986352",
    "8445061693744",
    "8445057827120",
    "8441183502640",
    "8441172689200",
    "8441155060016",
    "8441110724912",
    "8426916610352",
    "8417658994992",
    "8417644642608",
    "8415815467312",
    "8415811961136",
    "8415809536304",
    "8415406293296",
    "8415397052720",
    "8415379620144",
    "8413645766960",
    "8406249505072",
    "8398288683312",
    "8398260896048",
    "8348983099696",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (ketoList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF Keto ID PRODUCT TITLE

// START OF Keto ID PRODUCT TITLE
// Create the interval and store it in a variable
var filter_gourmet = setInterval(function () {
  Gourmet(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_gourmet);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function Gourmet() {
  const GourmetList = [
    "8534576333104",
    "8534567977264",
    "8534560244016",
    "8534551003440",
    "8534540910896",
    "8534530883888",
    "8534415278384",
    "8534412689712",
    "8534408593712",
    "8534399811888",
    "8526834532656",
    "8526828634416",
    "8526818443568",
    "8526793572656",
    "8526781710640",
    "8506757284144",
    "8506749616432",
    "8506743914800",
    "8506735132976",
    "8506730807600",
    "8506725859632",
    "8506714194224",
    "8465013342512",
    "8465005445424",
    "8464999481648",
    "8464972874032",
    "8464965534000",
    "8464950427952",
    "8464939680048",
    "8464070213936",
    "8464065429808",
    "8464062480688",
    "8464058843440",
    "8464008413488",
    "8464002777392",
    "8464000352560",
    "8445053108528",
    "8445051371824",
    "8445044293936",
    "8445030138160",
    "8443312013616",
    "8443299299632",
    "8441098174768",
    "8441083887920",
    "8441063276848",
    "8441058656560",
    "8426913071408",
    "8417584349488",
    "8417558888752",
    "8415807701296",
    "8415805014320",
    "8415802392880",
    "8413926883632",
    "8413924327728",
    "8413922787632",
    "8413462954288",
    "8411329233200",
    "8406225223984",
    "8406220112176",
    "8398250082608",
    "8398156792112",
    "8398031913264",
    "8348983427376",
    "8534402892080",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (GourmetList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF Keto ID PRODUCT TITLE

// START OF Athlete ID PRODUCT TITLE
// Create the interval and store it in a variable
var filter_athlete = setInterval(function () {
  Athlete(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_athlete);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function Athlete() {
  const AthleteList = [
    "8535630840112",
    "8535611179312",
    "8535576641840",
    "8534464954672",
    "8534462497072",
    "8534459285808",
    "8527071183152",
    "8527042478384",
    "8522836869424",
    "8522823958832",
    "8522816192816",
    "8522813014320",
    "8470933307696",
    "8470923116848",
    "8470910763312",
    "8464878666032",
    "8464871555376",
    "8464863756592",
    "8464855171376",
    "8464853729584",
    "8464852877616",
    "8458982162736",
    "8458977083696",
    "8458769236272",
    "8441286590768",
    "8441281904944",
    "8441264701744",
    "8417840922928",
    "8417837154608",
    "8417832730928",
    "8415832932656",
    "8415830507824",
    "8415828738352",
    "8415764840752",
    "8415761170736",
    "8415759827248",
    "8415757304112",
    "8413707731248",
    "8413706682672",
    "8413705339184",
    "8411155038512",
    "8411152646448",
    "8411151139120",
    "8398677967152",
    "8398673969456",
    "8398656340272",
    "8348982313264",
    "8348981756208",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (AthleteList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF Athlete ID PRODUCT TITLE

// START OF WeightLoss ID PRODUCT TITLE
// Create the interval and store it in a variable
var filter_WeightLoss = setInterval(function () {
  WeightLoss(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_WeightLoss);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function WeightLoss() {
  const WeightLossList = [
    "8553761931568",
    "8535567630640",
    "8535559307568",
    "8535552753968",
    "8535545250096",
    "8535531225392",
    "8534454337840",
    "8534451814704",
    "8534448144688",
    "8527019606320",
    "8527006335280",
    "8526979072304",
    "8526959935792",
    "8522807509296",
    "8522803478832",
    "8522773463344",
    "8522702258480",
    "8522688856368",
    "8522681418032",
    "8465254220080",
    "8465246945584",
    "8465229119792",
    "8465222369584",
    "8465193107760",
    "8465170661680",
    "8464851468592",
    "8464849928496",
    "8464848519472",
    "8464847765808",
    "8464845996336",
    "8464845111600",
    "8464844390704",
    "8445105963312",
    "8445101572400",
    "8445099311408",
    "8445096263984",
    "8445093019952",
    "8441253527856",
    "8441248645424",
    "8441243435312",
    "8441237766448",
    "8441232785712",
    "8417797538096",
    "8417784922416",
    "8415826116912",
    "8415824019760",
    "8415822053680",
    "8415752225072",
    "8415748161840",
    "8415728337200",
    "8413699178800",
    "8406325395760",
    "8406307111216",
    "8398521893168",
    "8398495351088",
    "8348982706480",
    "8348982575408",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (WeightLossList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF WeightLoss ID PRODUCT TITLE

// START OF Paleo ID PRODUCT TITLE
// Create the interval and store it in a variable
var filter_Paleo = setInterval(function () {
  WeightLoss(); // Call the filterBreakfast() function

  // Clear the interval after executing the code once
  clearInterval(filter_Paleo);
}, 100); // Execute the code every 1 second (1000 milliseconds)

function Paleo() {
  const PaleoList = [
    "8535517561136",
    "8535499374896",
    "8535480664368",
    "8535456678192",
    "8535435018544",
    "8534443458864",
    "8534439985456",
    "8534436839728",
    "8534432973104",
    "8534429532464",
    "8526933918000",
    "8526922645808",
    "8526887289136",
    "8526869561648",
    "8522675323184",
    "8522663133488",
    "8522640949552",
    "8522620174640",
    "8522606608688",
    "8522591142192",
    "8465160864048",
    "8465136943408",
    "8465128685872",
    "8465119346992",
    "8465100702000",
    "8465094902064",
    "8464842621232",
    "8464840950064",
    "8464840032560",
    "8464838852912",
    "8464836657456",
    "8464835445040",
    "8445088334128",
    "8445085417776",
    "8445081977136",
    "8445079060784",
    "8445075259696",
    "8441219514672",
    "8441217777968",
    "8441213714736",
    "8441207554352",
    "8441202737456",
    "8417768636720",
    "8417711030576",
    "8415820677424",
    "8415819661616",
    "8415817007408",
    "8415597691184",
    "8415586976048",
    "8415569117488",
    "8413676077360",
    "8406290235696",
    "8406278766896",
    "8398410285360",
    "8398380007728",
    "8348982804784",
    "8464834429232",
  ];

  const products = document.getElementsByClassName("product");
  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const loopCard = product.getElementsByClassName("loop-card")[0];
    const handle = loopCard.getAttribute("data-product-id");
    if (PaleoList.includes(handle)) {
      product.style.display = "block"; // Show the product
    } else {
      product.style.display = "none"; // Hide the product
    }
  }
}
// END OF Paleo ID PRODUCT TITLE

function All() {
  var products = document.getElementsByClassName("product");

  for (var i = 0; i < products.length; i++) {
    products[i].style.display = "block";
  }
}

const intervalId_filter = setInterval(() => {
  const targetElement = document.querySelector(
    ".loop-bundle-select-product-title"
  );
  const buttons = document.querySelectorAll(".filter_button_loop");
  if (targetElement) {
    clearInterval(intervalId_filter);
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        // Remove "active" class from all buttons
        buttons.forEach((btn) => btn.classList.remove("active_filter"));

        // Add "active" class to the clicked button
        button.classList.add("active_filter");
      });
    });
    const buttonContainer = document.querySelector(".button-container");
    if (buttonContainer) {
      const firstButton = buttonContainer.querySelector("button");
      if (firstButton) {
        firstButton.classList.add("active_filter");
      }
    }
  }
}, 100);
function waitForElement(selector, callback) {
  console.log(`Waiting for element with selector: ${selector}`); // Debug: Log when waiting for an element
  const intervalId = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      console.log(`Element with selector: ${selector} found`); // Debug: Log when the element is found
      clearInterval(intervalId);
      callback(element);
    }
  }, 300);
}
